import Cookies from 'js-cookie';
import { chatService } from 'services/chat';
import useSWR from 'swr';

export const useHeartbeat = () => {
	const fetcher = async () => {
		const accessToken = Cookies.get('accessToken');
		if (!accessToken) {
			// Skip heartbeat if not authenticated
			return null;
		}

		return chatService.sendHeartbeat();
	};

	useSWR('heartbeat', fetcher, {
		refreshInterval: 30000,
		revalidateOnFocus: false,
		revalidateOnReconnect: true,
		dedupingInterval: 25000,
	});
};
